import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from "react-i18next";

interface CountdownOverlayProps {
  isVisible: boolean;
  onComplete: () => void;
  countFrom?: number;
}

export function CountdownOverlay({ isVisible, onComplete, countFrom = 5 }: CountdownOverlayProps) {
  const { t } = useTranslation();
  const [count, setCount] = useState(countFrom);

  useEffect(() => {
    if (isVisible) {
      setCount(countFrom);
      
      const timer = setInterval(() => {
        setCount((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setTimeout(onComplete, 500); // Slight delay after 1 for "GO" or immediate start
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isVisible, countFrom, onComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center backdrop-blur-sm"
        >
          <motion.div
            key={count}
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1.2, opacity: 1 }}
            exit={{ scale: 2, opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="text-[150px] font-bold text-white font-mono"
            style={{ textShadow: '0 0 50px rgba(255, 107, 157, 0.5)' }}
          >
            {count > 0 ? count : t('teleprompter.countdown.go', 'GO!')}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
